import Sidebar from "../components/Sidebar";
import MobileBottomNav from "../components/MobileBottomNav";

const MainLayout = ({ children }) => {
  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar (desktop only) */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      {/* Main content area */}
      <div className="flex-1 p-4 md:p-6 pb-20 space-y-6">
        {children}
      </div>

      {/* Mobile bottom navigation */}
      <MobileBottomNav />
    </div>
  );
};

export default MainLayout;
